function injectStyle (ssrContext) {
  require("!!../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-19452cf6\",\"scoped\":false,\"hasInlineConfig\":false}!../vue-loader/lib/selector?type=styles&index=0!./upload-2.vue")
}
var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./upload-2.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-19452cf6\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../vue-loader/lib/selector?type=template&index=0!./upload-2.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-image-crop-upload/upload-2.vue
// module id = 170
// module chunks = 1